import type { ReactNode } from "react";
import { ClassActivityCategory, selectedCardStyles } from "../../constants/ClassActivityConstants";

interface ShareOptionCardProps {
    "data-testid"?: string;
    isSelected: boolean;
    isDisabled?: boolean;
    classActivityCategory: ClassActivityCategory;
    onClick: () => void;
    className?: string;
    children: ReactNode;
}

const ShareOptionCard = (props: ShareOptionCardProps) => {
    const getStateClasses = () => {
        if (props.isDisabled)
            return "border-2 border-transparent outline-1 outline-p6-grey-mid opacity-50 cursor-not-allowed";
        if (props.isSelected) return `${selectedCardStyles[props.classActivityCategory]} cursor-pointer`;
        return "border-2 border-transparent outline-1 outline-p6-grey-mid cursor-pointer";
    };

    return (
        <button
            type="button"
            data-testid={props["data-testid"]}
            onClick={props.onClick}
            disabled={props.isDisabled}
            aria-pressed={props.isSelected}
            className={`p-m rounded-[20px] text-center ${getStateClasses()} ${props.className ?? ""}`}
        >
            {props.children}
        </button>
    );
};

export default ShareOptionCard;
